import { atom } from "recoil";
import { emailValidation, PhoneFormatter, phoneValidation } from "utils";


interface IEMBEDED_FORM {
  label: string;
  name: string;
  placeholder: string;
  inputType: "number" | "text" | "password" | "date";
  width?: string;
  isCountryCodeVisible?: boolean;
  isError?: true;
  errorMessage?: string;
  validation?: (data: any) => any;
  value: string | number;
  type?: string;
  countryCode?: string;
  formatter?: (data: any) => any;
  emailValidation?: (data: any) => any;
  numberValidation?: (data: any) => any;
  numberFormatter?: (data: any) => any;    
}


export const EMBEDED_FORM:IEMBEDED_FORM =  {
    label: "Email or Phone Number",
    name: "email",
    placeholder: "Email or Phone Number",
    inputType: "text",
    errorMessage: "Please fix length",
    value: "",
    type: "input",
    width: "100%",
    countryCode: "+91",
    isCountryCodeVisible: false,
    emailValidation: (str: string) => {
      return emailValidation(str);
    },
    numberValidation: (str: string) => {
      return phoneValidation(str);
    },
    numberFormatter: (data: { value: string; countryCode: string }) => {
      const phoneFormatter = new PhoneFormatter();
      const formattedPhone = phoneFormatter.formatPhone(
        data.value,
        data.countryCode
      );
      return {
        formatted: formattedPhone ?? data.value,
        ...data,
        validationInput: formattedPhone?.replace(/\D/g, "") ?? data.value,
      };
    },
  }
export const EmbededFormState = atom({
    default:EMBEDED_FORM,
    key:"embeded-form-state"
}) 